module.exports = __webpack_public_path__ + "static/img/5.d9c60d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/5.png
// module id = TNKy
// module chunks = 0